import { CircleDashed, CircleSlash, Eye, Info, Loader2, TrendingDown, TrendingUp, TriangleAlert } from 'lucide-react';
import './StatusBadge.css';

const STATUS_ICONS = {
  loading: Loader2,
  error: TriangleAlert,
  degraded: TrendingDown,
  improved: TrendingUp,
  'no-data': CircleSlash,
  monitor: Eye,
  todo: CircleDashed,
  info: Info,
};

// Notch geometry, in px. The notch is NOTCH_SIZE square; RADIUS matches the .empty-card border radius
// and rounds all three turns of the outline. Lines sit on half pixels so the 1px stroke stays crisp.
const NOTCH_SIZE = 33;
const RADIUS = 8;
const OUTLINE_SIZE = NOTCH_SIZE + RADIUS;
const TOP = 0.5;
const RIGHT = OUTLINE_SIZE - 0.5;
const NOTCH_LEFT = RADIUS;
const NOTCH_BOTTOM = NOTCH_SIZE;

// Card top edge -> down the notch's left side -> along its bottom -> down into the card's right edge.
const OUTLINE_PATH = [
  `M 0 ${TOP}`,
  `A ${RADIUS} ${RADIUS} 0 0 1 ${NOTCH_LEFT} ${TOP + RADIUS}`,
  `V ${NOTCH_BOTTOM - RADIUS}`,
  `A ${RADIUS} ${RADIUS} 0 0 0 ${NOTCH_LEFT + RADIUS} ${NOTCH_BOTTOM}`,
  `H ${RIGHT - RADIUS}`,
  `A ${RADIUS} ${RADIUS} 0 0 1 ${RIGHT} ${NOTCH_BOTTOM + RADIUS}`,
].join(' ');

// Everything above/right of the outline, extended past the card edge so it also hides the card's
// original corner and its shadow there.
const SHADOW_COVER = 4;
const FILL_PATH = `${OUTLINE_PATH} L ${OUTLINE_SIZE + SHADOW_COVER} ${NOTCH_BOTTOM + RADIUS} `
  + `L ${OUTLINE_SIZE + SHADOW_COVER} ${-SHADOW_COVER} L 0 ${-SHADOW_COVER} Z`;

// Icon badge tucked into a notch in the card's top-right corner, with the card border wrapping around it.
// The label is shown as a hover tooltip and is the accessible name.
const StatusBadge = ({ status, label, className = '' }) => {
  const Icon = STATUS_ICONS[status];
  return (
    <span className="status-badge-notch">
      <svg
        className="status-badge-notch-outline"
        width={OUTLINE_SIZE}
        height={OUTLINE_SIZE}
        viewBox={`0 0 ${OUTLINE_SIZE} ${OUTLINE_SIZE}`}
        aria-hidden="true"
      >
        <path className="status-badge-notch-fill" d={FILL_PATH} />
        <path className="status-badge-notch-stroke" d={OUTLINE_PATH} />
      </svg>
      <span
        className={`status-badge status-badge--${status} ${className}`.trim()}
        role="img"
        aria-label={label}
        data-tooltip={label}
      >
        <Icon size={14} strokeWidth={2.25} aria-hidden="true" />
      </span>
    </span>
  );
};

export default StatusBadge;
